(function () {
  'use strict';

  angular.module('app.scouting').component('scoutingReportFieldChapter', {
    templateUrl: 'scouting/components/field/chapter.html',
    bindings: { params: '<', report: '<', editable: '<', selectedPlayer: '<', compact: '<' },
  });
})();
